// import {useTranslation} from 'react-i18next';

// eslint-disable-next-line react-hooks/rules-of-hooks
// const {t} = useTranslation();
export const CreatePadOptions = [
  {
    id: 1,
    name: 'Blank'
  },
  {
    id: 2,
    name: 'Import with data'
  },
  {
    id: 3,
    name: 'From a template'
  },
  {
    id: 4,
    name: 'Integrations'
  }
];

// input fields data array
export const dialogPopupInputFieldsData = [
  {
    id: 1,
    name: 'form_name',
    label: 'Form Name'
  }
];
